module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', _vm._l((_vm.serviceList ? _vm.serviceList : _vm.items), function(item) {
    return _c('v-list-item', {
      key: item.service
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      domProps: {
        "innerHTML": _vm._s(item.service)
      }
    })], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": item.status ? 'green' : 'red'
      }
    }, [_vm._v("cloud_circle")])], 1)], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c3ac8a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/ServicesHealthList.vue
// module id = 2215
// module chunks = 0